import { fanUsersJoinSegment } from '@zealot/shared/apiClient';
import { createClient } from '@zealot/shared/apiClient/client';
import { authFetch } from '@/lib/auth/authFetch';
import { NEW_API_URL } from '@/utils/api';
import logger from '@/utils/logger';

// gloss
export const joinInviteSegment = async (
  inviteTag: string | null | undefined,
  accessToken: string | null | undefined,
): Promise<boolean> => {
  if (!inviteTag || !accessToken) return false;

  const groupID = Number(inviteTag);
  if (!Number.isInteger(groupID) || groupID <= 0) return true;

  try {
    const client = createClient({
      baseUrl: NEW_API_URL,
      headers: { Authorization: `Bearer ${accessToken}` },
      fetch: authFetch,
    });
    const { error, response } = await fanUsersJoinSegment({ client, body: { groupID } });
    // why: only a 404 is definitive (drop the invite tag) — every other error must be treated as
    // why: transient and retried.
    if (error && response?.status !== 404) {
      logger.warn('joinInviteSegment: segment join request failed', { status: response?.status, groupID });
      return false;
    }
    return true;
  } catch (error) {
    logger.warn('joinInviteSegment: segment join errored', { err: error });
    return false;
  }
};
